import {Component} from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';

@Component({
  selector: 'app-rating-cell',
  template: `
    <app-rating [rating]="rating"></app-rating>
  `,
})

export class RatingCellComponent {
  rating: number | null = null;

  agInit(params: ICellRendererParams) {
    this.rating = params.value;
  }
}
